import { type ReactNode } from 'react';
import { useGlobalUI } from '@contexts/GlobalUiContext';
import { AppMenu } from './components/AppMenu/AppMenu';
import ProfileLink from './ProfileLink';
import s from './Sidebar.module.scss';
import { FooterMenu } from './models/FooterMenu';
import AppLogo from './components/AppLogo/AppLogo';
import AppSidebarToggle from './components/AppSidebarToggle/AppSidebarToggle';

export default function Sidebar(): ReactNode {
    const { menuContent } = useGlobalUI();

    return (
        <div className={s.sidebar}>
            <AppLogo className={s.logo} />
            <AppSidebarToggle />
            <div className={s.navigation}>
                <AppMenu menu={menuContent} />
            </div>
            <div className={s.footer}>
                <AppMenu menu={FooterMenu} />
                <ProfileLink />
            </div>
        </div>
    );
}
